// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "TableOfContents-module--bx--text-truncate--end--UbkvC";
export var bxTextTruncateFront = "TableOfContents-module--bx--text-truncate--front--Om2A+";
export var container = "TableOfContents-module--container---LqeK";
export var isCurrent = "TableOfContents-module--isCurrent--Fbsde";
export var toc = "TableOfContents-module--toc--VNNcr";
export var tocList = "TableOfContents-module--tocList--jZ8Rj";